import {ref, Ref} from "vue"
import { UserInfo } from "@requests"

const loggedInUser: Ref<UserInfo | null> = ref(null)

export default loggedInUser